jQuery(document).ready(function(){

	 jQuery('.collection-slider').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '.episode-reel'
	});
	
	jQuery('.episode-reel').slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  asNavFor: '.collection-slider',
	  dots: false,
	  arrows: false,
	  centerMode: false,
	  focusOnSelect: true,
	  swipeToSlide: true,
	  centerPadding: '40px',
	  responsive: [
	    {
	      breakpoint: 900,
	      settings: {
	        slidesToShow: 3
	      }
	    }
	  ]
	});

});

jQuery('.slider-next').click(function(){
	
	jQuery('.episode-reel').slick('slickNext');
	
});